'use strict';

var util = require('./property-util');

module.exports = {
    calculateAverages: function (linkPercentages) {
        var size = linkPercentages.length;
        var average = {};

        var total0 = 0;
        var total5 = 0;
        var total20 = 0;
        var total30 = 0;

        angular.forEach(linkPercentages, function (linkPercentage) {
            total0 += linkPercentage.zeroSeconds;
            total5 += linkPercentage.fiveSeconds;
            total20 += linkPercentage.twentySeconds;
            total30 += linkPercentage.thirtySeconds;
        });

        if (size === 0) {
            return;
        }

        average.avgZeroSeconds = total0 / size;
        average.avgFiveSeconds = total5 / size;
        average.avgTwentySeconds = total20 / size;
        average.avgThirtySeconds = total30 / size;

        return average;
    },

    calculateStyle: function (min, goodValue, value) {
        var style = "danger";

        if (!angular.isDefined(value)) {
            return style;
        }

        if (value === 0) {
            return "default";
        }

        if (value >= goodValue) {
            style = "success";
        } else {
            if ((value >= min) && (value < goodValue)) {
                style = "warning";
            }
        }
        return style;
    },


    getCurlMessage: function (code) {
        var curl = [];
        curl[0] = "Success";
        curl[6] = "Couldn't resolve host. The given remote host was not resolved.";
        curl[7] = "Failed to connect to host.";
        curl[8] = "Operation timeout.";
        curl[18] = "Partial file. Only a part of the file was transferred.";
        curl[28] = "Operation timeout.";
        curl[35] = "SSL connect error. The SSL handshaking failed.";
        curl[47] = "Too many redirects.";
        curl[52] = "The server didn't reply anything, which here is considered an error.";
        curl[56] = "Failure in receiving network data.";
        curl[63] = "Maximum file size exceeded.";

        var message = curl[code];
        if (!angular.isDefined(message)) {
            message = "Please look up code in manual of curl.";
        }
        return message;
    },

    createCsvUrlPeriod: function (message, trainDataQuery) {
        return "rest/csv/period?message=" + message + "&token=" + trainDataQuery.token + "&" + module.exports.addTrainPeriodQueryParams(trainDataQuery);
    },

    addTrainPeriodQueryParams: function (trainDataQuery) {
        return "trainId=" + trainDataQuery.trainId + "&projectId=" + trainDataQuery.projectId + "&from=" + trainDataQuery.from + "&to=" + trainDataQuery.to;
    },


    extendWithSQIMetaData: function (statistic, metaData, invalidSqiValue) {
        if (statistic) {
            statistic.cssClass = module.exports.createSpecificsClass(statistic, invalidSqiValue);
            statistic.unit = metaData.unit;
            statistic.value = module.exports.roundToTwo(statistic.value);
            statistic.fullDescription = metaData.description;
            statistic.shortDescription = metaData.shortDescription;
        }

        return statistic;
    },

    createSpecificsClass: function (specific, invalidValue) {
        var result = "";
        if (specific) {
            if (specific.reverse === false) {
                if (specific.value < specific.bad) {
                    result = 'danger';
                } else if (specific.value >= specific.bad && specific.value < specific.perfect) {
                    result = 'warning';
                } else if (specific.value >= specific.perfect) {
                    result = 'success';
                }
            } else {
                /* reversed */
                if (specific.value >= specific.bad) {
                    result = 'danger';
                } else if (specific.value <= specific.bad && specific.value > specific.perfect) {
                    result = 'warning';
                } else if (specific.value <= specific.perfect) {
                    result = 'success';
                }
            }
    
            if (specific.value === invalidValue) {
                result = 'invalid';
            }
        }


        return result;
    },

    isSubstringEqualTo: function (text, start, end, expectedResult) {
        return text.substring(start, end).toLowerCase() === expectedResult;
    },

    createPeriodUpToNow: function (days) {
        var newFrom = new Date(new Date().getTime() - ((days - 1) * 24 * 60 * 60 * 1000));
        newFrom.setHours(0);
        newFrom.setMinutes(0);
        newFrom.setSeconds(0);
        newFrom.setMilliseconds(0);

        var newTo = new Date();
        newTo.setHours(23);
        newTo.setMinutes(59);
        newTo.setSeconds(59);
        newTo.setMilliseconds(999);


        return {
            "start": newFrom,
            "end": newTo
        }
    },

    createPeriodHoursAgo: function (hours) {
        var newFrom = new Date(new Date().getTime() - ((hours) * 60 * 60 * 1000));
        var newTo = new Date();

        return {
            "from": newFrom,
            "to": newTo
        }
    },

    roundToTwo: function (num) {
        return +(Math.round(num + "e+2") + "e-2");
    },

    getDaysBetween: function (firstDate, lastDate) {
        var oneDay = 24 * 60 * 60 * 1000;
        var diffDays = Math.round(Math.abs((firstDate.getTime() - lastDate.getTime()) / (oneDay)));
        return diffDays;
    },

    getTimeString: function (milliseconds) {
        var hours = Math.floor(milliseconds / (1000 * 60 * 60));
        milliseconds = milliseconds - (hours * (1000 * 60 * 60));
        var mins = Math.floor(milliseconds / (1000 * 60));
        milliseconds = milliseconds - (mins * (1000 * 60));
        var secs = Math.floor(milliseconds / 1000);

        return "" + module.exports.pad(hours, 2) + ":" + module.exports.pad(mins, 2) + ":" + module.exports.pad(secs, 2);
    },

    durationToHMS: function (milliseconds) {
        var hours = Math.floor(milliseconds / (1000 * 60 * 60));
        milliseconds = milliseconds - (hours * (1000 * 60 * 60));
        var mins = Math.floor(milliseconds / (1000 * 60));
        milliseconds = milliseconds - (mins * (1000 * 60));
        var secs = Math.floor(milliseconds / 1000);

        return "" + hours + ":" + module.exports.pad(mins, 2) + ":" + module.exports.pad(secs, 2);
    },

    pad: function (num, size) {
        return ('0' + num).substr(-size);
    },

    addDays: function (date, days) {
        if (!(date instanceof Date ) || isNaN(date.getTime()) || isNaN(days)) {
            return null;
        }
        var newDate = new Date(date.getTime());
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    },

    isToday: function (date) {
        if (!(date instanceof Date ) || isNaN(date.getTime())) {
            return null;
        }
        var beginningOfToday = new Date();
        beginningOfToday.setHours(0);
        beginningOfToday.setMinutes(0);
        beginningOfToday.setSeconds(0);
        beginningOfToday.setMilliseconds(0);
        var endOfToday = new Date();
        endOfToday.setHours(23);
        endOfToday.setMinutes(59);
        endOfToday.setSeconds(59);
        endOfToday.setMilliseconds(99);
        return (date.getTime() <= endOfToday.getTime() && date.getTime() >= beginningOfToday.getTime());
    },

    beginAndEndOfDate: function (date) {
        if (!(date instanceof Date ) || isNaN(date.getTime())) {
            return null;
        }
        var beginningOfToday = angular.copy(date);
        beginningOfToday.setHours(0);
        beginningOfToday.setMinutes(0);
        beginningOfToday.setSeconds(0);
        var endOfToday = angular.copy(date);
        endOfToday.setHours(23);
        endOfToday.setMinutes(59);
        endOfToday.setSeconds(59);

        return {'from': beginningOfToday, 'to': endOfToday};
    },
//new Date(year, month[, day[, hour[, minutes[, seconds[, milliseconds]]]]]);
    parseUrlDateStringToDate: function (urlDate) {
        if (!util.isDefined(urlDate)) {
            return undefined;
        }
        var parts = urlDate.split('-');

        if (parts.length < 4) {
            return undefined;
        }

        var time = parts[3].split(':');

        if (time.length === 2) {
            // months start at 0
            return new Date(parts[0], --parts[1], parts[2], time[0], time[1], 0);
        } else {
            return new Date(parts[0], --parts[1], parts[2], time[0], time[1], time[2]);
        }
    },

    isValidDate: function (dateValue) {
        return !isNaN(dateValue)
    },

    toDate: function (anyDate) {
        var date = undefined;

        if (util.isDefined(anyDate)) {
            if (anyDate instanceof Date && module.exports.isValidDate(anyDate)) {
                date = anyDate;
            } else {
                var tmpDate = new Date(anyDate);
                if (tmpDate instanceof Date && module.exports.isValidDate(tmpDate)) {
                    date = tmpDate;
                } else {
                    date = module.exports.parseUrlDateStringToDate(anyDate);
                }
            }
        }
        if (date === undefined || !module.exports.isValidDate(date)) {
            console.warn("Not able to parse date: " + anyDate);
        }
        return date;
    },

    toUTCMs: function (date) {
        var offset = date.getTimezoneOffset();
        var utcms = 0;
        if (offset < 0) {
            utcms = date.getTime() - (( -1 * offset) * 60 * 1000);
        } else {
            utcms = date.getTime() - (offset * 60 * 1000);
        }
        return utcms;
    },

    isSameDay: function (date1, date2) {
        return date1.getYear() === date2.getYear() && date1.getMonth() === date2.getMonth() && date1.getDay() === date2.getDay();
    },

    formatStringForDisplay: function (value) {
        var toBeFormatted = value;
        toBeFormatted = toBeFormatted.toLowerCase();
        var formatGroups = toBeFormatted.split(" ");

        for (var entryIndex in formatGroups) {
            if (formatGroups.hasOwnProperty(entryIndex)) {
                var entry = formatGroups[entryIndex];
                formatGroups[entryIndex] = "" + entry.charAt(0).toUpperCase() + entry.substring(1);
            }

        }
        return formatGroups.join(" ");
    },

    /**
     * Generates a color by providing a value, a minimum and a maximum
     * The color ranges from red to green (or green to red)
     * @param value     value for which the color will be calculated
     * @param min       minimum value (hard-capped)
     * @param max       maxmimum value (hard-capped)
     * @param reverse   for some qualities low values are good (green), for others low values are bad(red)
     * @param logscale
     * @returns {string}
     */
    generateColorByValue: function (value, min, max, reverse, logscale) {
        if (value === -1) {
            return "#757575"; // grey
        }
        var tmp;
        if (util.isDefined(logscale) && logscale && value > 0) {
            if (min > 0) {
                min = Math.log(min) / Math.LN10;
            }
            tmp = (Math.log(value) / Math.LN10 - min) / (Math.log(max) / Math.LN10 - min);
        } else {
            tmp = (value - min) / (max - min);
        }

        var G = (255 * tmp);
        var R = (255 * (1 - tmp));
        var B = 0;
        if (util.isDefined(reverse) && reverse) {
            R = (255 * tmp);
            G = (255 * (1 - tmp));
        }
        return "#" + module.exports.rgbToHex(R, G, B);
    },
    rgbToHex: function (R, G, B) {
        return module.exports.toHex(R) + module.exports.toHex(G) + module.exports.toHex(B)
    },
    toHex: function (n) {
        n = parseInt(n, 10);
        if (isNaN(n)) return "00";
        n = Math.max(0, Math.min(n, 255));
        return "0123456789ABCDEF".charAt((n - n % 16) / 16)
            + "0123456789ABCDEF".charAt(n % 16);
    },

    fromPercent: function (percent) {
        var hasPct = percent.indexOf('%') >= 0;
        if (!hasPct) {
            console.log("expected "  + percent + " to be a percentage value.");
        }

        return parseFloat(percent) / 100.0;
    },

    getFirstCheckedItem: function (array) {
        var selected;
        array.some(function (item) {
            if (util.isChecked(item)) {
                selected = item;
                return true;
            }
        });
        return selected;
    },

    formatLinkName: function (text) {
        return text.toString().toLowerCase().replace(/cell/g, 'm').replace(/-/g, '').toUpperCase();
    },

    parseStringToBoolean: function (string) {
        if (string === true || string === "true") {
            return true;
        } else if (string === false || string === "false") {
            return false;
        }
    },

    removeLinksContaining: function (linkName, links) {
        var nonVlinks = [];
        if (util.isDefined(links)) {
            links.forEach(function (link) {
                if (link.name.indexOf(linkName) < 0) {
                    nonVlinks.push(link)
                }
            })
        }
        return nonVlinks;
    },

    removeVLinkSubDiscriminators: function (links) {
        var nonVlinks = [];
        if (util.isDefined(links)) {
            links.forEach(function (link) {
                if (link.name.indexOf("VLINK") < 0) {
                    nonVlinks.push(link)
                }
            })
        }
        return nonVlinks;
    },

    verifyLabelBasedOnUsersAndSchedule: function (users, trip) {

        var hasTrip = util.isDefined(trip) && util.isDefined(trip.tripId) && !trip.tripId.includes('no-service');
        var hasUsers = util.isDefined(users) && users > 0;

        if (hasTrip && !hasUsers) {
            return "badge-danger";
        }

        if (hasUsers && !hasTrip) {
            return "badge-warning";
        }

        if (!hasTrip && !hasUsers) {
            return "badge-secondary";
        }

        if (hasTrip && hasUsers) {
            return "badge-success"
        }
    },

    determineLabelClassForLink: function (link) {

        if (util.isTrue(link.vpnUp)) {
            if (module.exports.isBackupLink(link)) {
                //link up, backup slot--> BLUE
                return "badge-primary";
            } else {
                return "badge-success"
            }
        } else {
            //vpn down, backup slot --> PURPLE
            if (module.exports.isBackupLink(link)) {
                return "badge-purple";
            } else {
                //vpn down, link is disabled --> GREY
                if (util.isTrue(link.disabled)) {
                    return "badge-secondary";
                } else {
                    if (util.isDefined(link.latestQuality) && link.latestQuality > 0 && link.latestQuality < 70) {
                        return "badge-warning";
                    }
                }
            }
        }
        return "badge-danger";
    },

    isBackupLink: function (link) {
        return util.isDefined(link.backup) && link.backup;
    },

    roundTo: function (value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    },

    toMegaByte: function (value, thousand24) {
        var megabytes = value / (thousand24 * thousand24);
        return module.exports.roundTo(megabytes, 2);
    }
};



